import {React,useState,useEffect }from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { Button, Modal, ModalHeader } from 'reactstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Axios from 'axios'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
    const[email, setEmail] = useState("");
    const [storeID, setStoreid] = useState('');
    const [storename, setStorename] = useState('')
    const [branchID, setBranchid] = useState('');
    const [branchName, setBranchname] = useState('');
    const [username, setUsername] = useState('');
    const [firstname, setFirstname] = useState('');
    const [middlename, setMiddlename] = useState('');
    const [lastname, setLastname] = useState('');
    const [phone, setPhone] = useState('');
    const [role, setRole] = useState('');
    const [newFirstname, setNewfirstname] =useState('');
    const [newMiddlename, setNewmiddlename] = useState('');
    const [newLastname, setNewlastname] = useState('');
    const [newEmail, setNewemail] = useState('');
    const [newPhone, setNewphone] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmpassword] =  useState('')
    const [id, setID] = useState('');
    const [modal, setModal] = useState(false);
    const [message, setMessage] = useState('');
    const [ticketID, setTicketid] = useState('');
    const [modal2, setModal2] = useState(false);
    const [modal3, setModal3] = useState(false);
    const [tickets, setTickets] = useState([])
    const navigate = useNavigate();



    useEffect(() => {
        const fetchProfile = async () => {
          try {
            const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/profile', {
              credentials: 'include', // to send cookies
            });
            const data = await res.json();
    
            if (data.valid) {
              setEmail(data.email)
            } else {}
          } catch (error) {} 
        };
    
        fetchProfile();
      }, []);
    
      //get store id
      useEffect(()=>{
       const fetchData = async()=>{
          try{
            const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
            const data = await res.json();
            setStoreid(data.store_id)
            setBranchid(data.branch_id)
            setUsername(data.username)
            setFirstname(data.firstname)
            setMiddlename(data.middlename)
            setLastname(data.lastname);
            setPhone(data.phone)
            setRole(data.role)
            setID(data.id)
          }
          catch(err){}
       }
    
       if(email){
        fetchData();
       }
       
      },[email])

      const fetchUser = async()=>{
        try{
          const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
          const data = await res.json();
          setStoreid(data.store_id)
          setBranchid(data.branch_id)
          setUsername(data.username)
          setFirstname(data.firstname)
          setMiddlename(data.middlename)
          setLastname(data.lastname);
          setPhone(data.phone)
          setRole(data.role)
          setID(data.id)
        }
        catch(err){}
     }
    
      useEffect(()=>{
        const fetchData = async()=>{
          try{
            const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getStoredetails?storeid=${storeID}`)
            const data = await res.json();
    
            setStorename(data.store_name)
          }
          catch(err){}
        }
    
        if(storeID){
          fetchData();
        }
    
      },[storeID])

      useEffect(() => {
        const fetchBranchDetails = async () => {
          try {
            const response = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getBranchdetails?branch=${branchID}`); // Replace '1' with the desired branch ID
            const data = await response.json();
            setBranchname(data.branchName)
    
           
          } catch (error) {
            console.error("Error fetching branch details:", error);
          }
        };
        if(branchID){
            fetchBranchDetails();
        }
        
      }, [branchID]);

      useEffect(() => {
        const fetchTickets = async () => {
          try {
            const response = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getUsertickets?email=${email}`); // Replace '1' with the desired branch ID
            const data = await response.json();
            setTickets(data)
    
           
          } catch (error) {
            console.error("Error fetching branch details:", error);
          }
        };
        if(branchID){
            fetchTickets();
        }
        
      }, [email]);

      const updateUser =async()=>{

        if(password == '' && confirmPassword == ''){
            const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/updateUser1',{
                method:'POST',
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    firstname,lastname,middlename,id,phone
                }),
                credentials:'include'
            })
            const data = await res.json();
            const{success} = data;
            if(success == true){
                toast.success('Changes saved')
                fetchUser();
            }
            else{
                toast.error('Something went wrong')
            }


        }

        if(password !== '' && confirmPassword !== ''){
            const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/updateUser2',{
                method:'POST',
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    firstname,lastname,middlename,id,phone,password
                }),
                credentials:'include'
            })
            const data = await res.json();
            const{success} = data;
            if(success == true){
                toast.success('Changes saved')
                fetchUser();
            }
            else{
                toast.error('Something went wrong')
            }


        }

      }


      const toggle=()=>{
        setModal(!modal)
      }
      const toggle2=()=>{
        setModal2(!modal2)
      }
      const toggle3=()=>{
        setModal3(!modal3)
      }
      const close=()=>{
        setModal2(!modal2)
      }
      const close3=()=>{
        setModal3(false)
      }

      const createTicket =async()=>{
        if(message !== ''){
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'; 
            let result = '';
            
            // Generate a random 8-character string
            for (let i = 0; i < 5; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex]; 
            }
            const ticket = `RDT-${result}`;
            setTicketid(ticket)

            const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/submitTicket',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    email,storeID,message,ticket
                }),
                credentials:"include"
            })

            const data = await res.json();
            const{success} = data;
            if(success == true){
                toggle2()
                setModal(false)
            }
            else{
                toast.error('Something went wrong')
            }
        }
      }

    const logout =async()=>{
        const res = await fetch('https://easyboxstoresapi.uuidesign.xyz/api/logout');
        const data = await res.json();
        const {logout} = data;
        if(logout == true){
            navigate('/login')
        }
        else{
            toast.error('something went wrong')
        }

    }

    const deleteAccount =async()=>{
        const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/deleteMyaccount?id=${id}`)
        const data = await res.json();
        const{success} = data;
        if(success == true){
            logout();
        }
        else{
            toast.error('Something went wrong')
        }

    }
    
  return (
    <div className='ordersContainer'>
    <ToastContainer />
         <Breadcrumbs title="Easybox" breadcrumbItem="My Profile" />
         <div className="card" style={{padding:'10px'}}>
         <div className="profileContainer">
            <div className="profileLeft">
                <img src="/user.webp" alt="" className='profileImage' />

                <div className="profileleftDetails">
                <p className='username'>@{username}</p>
                <h5 className='fullname'>{firstname} {lastname}</h5>
                <p className='moredetails'>{email}</p>
                <p className='moredetails'>{phone}</p>
                <p className='moredetails'>{storename}</p>
                <p className='moredetails'>Branch: {branchName}</p>
                <div className="profileButtons">
                    <Button color='danger' onClick={logout}>Logout</Button>
                    <Button  className='deactivateButton'  onClick={toggle3}>Delete My Account</Button>
                </div>

                </div>
               
                
               
                
            </div>
            <div className="profileRight">
            <div className="accountDetails">
                <h4>Edit account details</h4>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Username" >
                    <Form.Control  className='inputSearch' value={username}  type="text" placeholder="Username" disabled/>
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="First name" onChange={(e)=>{setFirstname(e.target.value)}} >
                    <Form.Control  className='inputSearch'  type="text" value={firstname} />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Middle name" onChange={(e)=>{setMiddlename(e.target.value)}} >
                    <Form.Control  className='inputSearch' value={middlename}  type="text"  />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Last name" onChange={(e)=>{setLastname(e.target.value)}} >
                    <Form.Control  className='inputSearch' value={lastname}  type="text" />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email"  >
                    <Form.Control  className='inputSearch' value={email}  type="text" placeholder="Username" disabled />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Phone Number" onChange={(e)=>{setPhone(e.target.value)}} >
                    <Form.Control  className='inputSearch' value={phone}  type="text"  />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Role"  >
                    <Form.Control  className='inputSearch' value={role}  type="text" placeholder="Username" disabled />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="New password" onChange={(e)=>{setPassword(e.target.value)}} >
                    <Form.Control  className='inputSearch' value={password}  type="password" placeholder="Username" />
                </FloatingLabel>
                <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Confirm new password" onChange={(e)=>{setConfirmpassword(e.target.value)}} >
                    <Form.Control  className='inputSearch' value={confirmPassword}  type="password" placeholder="Username" />
                </FloatingLabel>
                <Button style={{marginTop:'2%'}} color='success' onClick={updateUser}>Save changes</Button>

            </div>
            

            </div>
            <div className="profileSupport">
            <div className="supportDetails">
            <h4>Suport</h4>
            <p>Frequently Asked Questions</p>
            <div>
                <Accordion>
                    <AccordionSummary
                    expandIcon={<ArrowDownwardIcon />}
                     aria-controls="panel2-content"
                    id="panel2-header"
                    >
                    <Typography style={{fontSize:'12px'}}>Does Easybox provide API's to developers?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography style={{fontSize:'12px'}}>
                        Yes. Download our API documentation on www.Easybox.com/documentation.
                    </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    >
                    <Typography style={{fontSize:'12px'}}>Does Easybox calculate distance and cost as per rates of the company?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography>
                        Yes. Delivery companies can set their rates which are applied in calculating cost in respect to the distance
                    </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    >
                    <Typography style={{fontSize:'12px'}}>Does the platform provide the quickest route to delivery location for riders to use?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography>
                        Yes. Our maps always give the quickest routes for riders and trucks.
                    </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    >
                    <Typography style={{fontSize:'12px'}}>Are there role based restrictions?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography>
                        Yes. Some functionalities are only available to particular users per role.
                    </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    >
                    <Typography style={{fontSize:'12px'}}>Is it possible to download reports?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography>
                        Yes. Click the reports tab to export reports in PDF format.
                    </Typography>
                    </AccordionDetails>
                </Accordion>
                </div>
                <p className='contactSupport' onClick={toggle}>Need to contact support?</p>
                <p style={{textDecoration:'underline'}}>Latest tickets</p>
                {tickets.map((val,index)=>{
                    const postDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.createdAt)
                    const postTime =  new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(val.createdAt)
                    return(
                        <p>{val.ticketID} - {val.status}</p>
                    )
                })}

            </div>
               
            </div>
         </div>
         </div>

         <Modal isOpen={modal} toggle={toggle} size="md">
            <ModalHeader>Contact support</ModalHeader>
            <div className="modalContainer">
                <p>Enter your message</p>
                <FloatingLabel className='formInput' controlId="floatingTextareaGrid" label="Your message">
                    <Form.Control 
                        as="textarea" 
                        className='inputSearch' 
                        onChange={(e)=>{setMessage(e.target.value)}}
                        placeholder="Enter your message" 
                        style={{ height: '100px' }} 
                    />
                </FloatingLabel>
                <Button style={{marginTop:'2%'}} color='success' onClick={createTicket} >Submit</Button>
            </div>

         </Modal>

         <Modal isOpen={modal2} toggle={toggle2} size='sm'>
            <div className="modalContainer">
                <h3 className='username' style={{color:'green', fontWeight:'900'}}>SUCCESSFUL!</h3>
                <h5 className='username'>Tickect number: {ticketID}</h5>
                <Button color='danger' style={{marginTop:'6%'}} onClick={close}>Close</Button>
            </div>
         </Modal>

         <Modal isOpen = {modal3} toggle={toggle3}>
         <ModalHeader>Delete Account</ModalHeader>
         <div className="modalContainer">
                <p>Do you want to delete this account? This action cannot be reversed.</p>
            <div className="modalButtons">
                <Button color='success' onClick={close3}>NO</Button>
                <Button color='danger' onClick={deleteAccount} style={{marginLeft:'3%'}}>YES</Button>
            </div>
         </div>

         </Modal>
    </div>
  )
}
